/* Which of the three models the reader is working with.

   A prompt is offered for Claude, ChatGPT and Gemini, and a teacher uses one of
   them. Choosing it again on each of ten prompts in a lesson, and again on the
   next page, is the kind of small friction that makes a page feel like it is
   not paying attention — so the choice is made once and every prompt on every
   page follows it.

   It is held here, in the module, and not:

     in the server's settings, which decide policy for everyone. This is one
     reader's preference and switching it must not switch it for a room;

     in localStorage, which in this portal decides nothing — a stale value in
     one browser is a class of bug the rewrite went out of its way to remove;

     in the address, which on this page is reserved for the filter, because a
     link to "the planning prompts" is something a teacher sends and a link to
     "the planning prompts, as ChatGPT would take them" is not.

   Module state, like the cached index in hooks.ts: it survives navigation
   inside the session and is gone on reload, which is exactly as long as a
   preference of this weight deserves to live.

   OWNED BY ITEM 4 OF PLAN.md. */

import { useSyncExternalStore } from "react";
import type { PromptModel } from "./types";

let chosen: PromptModel = "claude";
const watchers = new Set<() => void>();

function subscribe(fn: () => void): () => void {
  watchers.add(fn);
  return () => { watchers.delete(fn); };
}

function read(): PromptModel {
  return chosen;
}

export function setModel(model: PromptModel): void {
  if (model === chosen) return;
  chosen = model;
  for (const fn of [...watchers]) fn();
}

export function useModel(): PromptModel {
  /* The same value on the server render and the client: there is no hydration
     here, but reading through one function keeps it that way if there ever is. */
  return useSyncExternalStore(subscribe, read, read);
}
